/* eslint-disable */
import anime from 'animejs';

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {

    var isReset = false;
    const originalLoadMoreButtonLabel = $( ".link-listing-show-more" ).children('span').text();

    var isRelatedReset = false;

    $( ".related-articles-show-more" ).click(function(event)
    {

        event.preventDefault();

        let currentArticleList = $(this).closest('.related-articles').find('.related-articles-grid'); //jquery obj

        console.log (currentArticleList);

        const currentID = $(this).closest('.related-articles').attr('id');
        let hiddenElements =  $( currentArticleList ).find( ".related-article-item.hidden" );
        let allRelatedElements =  $( currentArticleList ).find( ".related-article-item" );
        let iTheElementCount = $(this).closest('.related-articles').attr('data-element-count');
        var counter = 0;
        var iTheDelay = 80;
        const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

        console.log (isRelatedReset);
        if (!isRelatedReset)
        {
            hiddenElements.each(function() {
              if (counter < iTheElementCount) {
                console.log ('1');
                setTimeout(() => {
                  $(this).removeClass('hidden -in').addClass('-out');
                  console.log ('2');
                }, iTheDelay * counter);
              }
              counter++;
            });

            setTimeout(() => {
              if (!$( currentArticleList ).find( ".related-article-item.hidden" ).length) {

                  $(this).children('span').text($(this).attr("data-close-label"));
                  $(this).children('.icon').addClass('arrow-up');
                  isRelatedReset = true;
              }
            }, 200);

          } else {

            iTheDelay = 100;
            isRelatedReset = false;
            $(this).children('.icon').removeClass('arrow-up');
            $(this).children('span').text($(this).attr("data-open-label"));

            var animateTo = $('#'+currentID);

            $(allRelatedElements.get().reverse()).each(function(index)
            {
                if (allRelatedElements.length - index > iTheElementCount)
                {
                    setTimeout(() => {
                        $(this).removeClass('-in').addClass('-out');
                        setTimeout(() => {
                          $(this).addClass('hidden');
                  }, 200);

                }, iTheDelay * index)

              }
            });

            setTimeout(() => {
              anime({
                targets: scrollElement,
                scrollTop: animateTo.offset().top,
                duration: 600,
                easing: 'easeInOutQuart'
              });
            }, 800);

          }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/components/related-articles.js